import { routes } from './leadinConfig';
const flatUrls = (key, route) => {
    if (typeof route === 'string') {
        return {
            [key]: route,
        };
    }
    return Object.keys(route).reduce((agg, childKey) => {
        const childRoute = route[childKey];
        return {
            ...agg,
            ...flatUrls(key + childKey, childRoute),
        };
    }, {});
};
const urlsMap = Object.keys(routes).reduce((agg, key) => ({
    ...agg,
    ...flatUrls(key, routes[key]),
}), {});
export default urlsMap;
